const STORY_READ_STORAGE_KEY = 'cchi-kung:story-read-posts';

export const getReadStoryIds = () => {
    if (typeof window === 'undefined') {
        return [];
    }

    try {
        const storedValue = window.localStorage.getItem(STORY_READ_STORAGE_KEY);
        const parsedValue = storedValue ? JSON.parse(storedValue) : [];

        return Array.isArray(parsedValue) ? parsedValue : [];
    } catch (error) {
        console.warn('Failed to read story state from localStorage:', error);
        return [];
    }
};

export const markStoryAsRead = (storyId) => {
    if (typeof window === 'undefined' || !storyId) {
        return;
    }

    try {
        const readStoryIds = new Set(getReadStoryIds());
        readStoryIds.add(storyId);
        window.localStorage.setItem(STORY_READ_STORAGE_KEY, JSON.stringify([...readStoryIds]));
    } catch (error) {
        console.warn('Failed to save story state to localStorage:', error);
    }
};
